<template>
    <div>
        <el-form  :model="formData" ref="formRef" label-width="110px" size="mini">
            <div class="flex">
                <!--<el-form-item  prop="vc_invoice_number" label="发票号" required>
                    <el-input :disabled="canEdit"  class="changeinput" size="mini" v-model="formData.vc_invoice_number"  ></el-input>
                </el-form-item>-->
                <el-form-item  prop="vc_contract_number" label="合同号" required>
                    <el-input :disabled="canEdit"  class="changeinput" size="mini" v-model="formData.vc_contract_number"  ></el-input>
                </el-form-item>
                <!--<el-form-item  prop="dt_expire_time" label="到期时间" required>
                    <el-date-picker :disabled="canEdit"
                                    v-model="formData.dt_expire_time"
                                    size="mini"
                                    class="changeinput"
                                    format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="选择日期"
                    >
                        &lt;!&ndash;:picker-options="pickerOptions"&ndash;&gt;
                    </el-date-picker>
                </el-form-item>-->
                <el-form-item  prop="i_account_period" label="付款期(天" required>
                    <el-input-number :disabled="canEdit" class="changeinput number" v-model="formData.i_account_period" :min="0" :controls="false"></el-input-number>
                </el-form-item>
                <!--<el-form-item  prop="vc_target_company" label="目的地公司">
                    <el-select :disabled="canEdit"  @change="changeData($event,'com_md')" remote :remote-method="remoteMethodcom" class="marr4" v-model="formData.vc_target_company" size="mini" @clear="cleardata('com_md')"  clearable filterable >
                        <el-option
                                v-for="item in comList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>-->
            </div>
            <div class="flex">
                <el-form-item  prop="vc_buyer" label="买方" required>
                    <el-select :disabled="canEdit"  @change="changeData($event,'ks')" remote :remote-method="remoteMethodks" class="marr4" v-model="formData.vc_buyer" size="mini" @clear="cleardata('ks')"  clearable filterable >
                        <el-option
                                v-for="item in ksList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--<el-form-item  prop="vc_buyer_po" label="买方PO号" required>
                    <el-input :disabled="canEdit"  class="changeinput" size="mini" v-model="formData.vc_buyer_po"  ></el-input>
                </el-form-item>-->
                <el-form-item  prop="vc_seller" label="卖方" required>
                    <el-select :disabled="canEdit"  @change="changeData($event,'com')" remote :remote-method="remoteMethodcom" class="marr4" v-model="formData.vc_seller" size="mini" @clear="cleardata('com')"  clearable filterable >
                        <el-option
                                v-for="item in comList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  prop="vc_ckname" :label="$t('form_warehouse')" required>
                    <el-select :disabled="canEdit"  @change="changeData($event,'ck')" remote :remote-method="remoteMethodck" class="marr4" v-model="formData.vc_ckname" size="mini" @clear="cleardata('ck')" clearable filterable >
                        <el-option
                                v-for="item in ckData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>
            <div class="flex">
                <el-form-item  prop="vc_product" label="品种" required>
                    <el-select :disabled="canEdit"  @change="changeData($event,'pz')" remote :remote-method="remoteMethodpz" class="marr4" v-model="formData.vc_product" size="mini" @clear="cleardata('pz')"  clearable filterable >
                        <el-option
                                v-for="item in pzList"
                                :key="item.i_id"
                                :label="item.vc_name_cn"
                                :value="item.vc_name_cn">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  prop="vc_product_type" label="品种分类" required>
                    <el-input disabled  class="changeinput" size="mini" v-model="formData.vc_product_type" ></el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="vc_unit" label="计量单位" required>
                    <el-input :disabled="canEdit"  class="changeinput" size="mini" v-model="formData.vc_unit"  ></el-input>
                </el-form-item>
            </div>
            <div class="flex">
                <el-form-item  prop="vc_bzname" label="币种" required>
                    <el-select :disabled="canEdit"  @change="changeData($event,'bz')" remote :remote-method="remoteMethodbz" class="marr4" v-model="formData.vc_bzname" size="mini" @clear="cleardata('bz')" clearable filterable >
                        <el-option
                                v-for="item in bzList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  prop="vc_bzname" label="币种符号" required>
                    <el-input disabled class="changeinput" size="mini" v-model="formData.vc_bz_symbol"  ></el-input>

                </el-form-item>
                <el-form-item  prop="f_rate"  label="汇率" required>
                    <el-input :disabled="canEdit" class="changeinput" size="mini" v-model="formData.f_rate"  ></el-input>
                </el-form-item>
               <!-- <el-form-item  prop="vc_trade_type" label="贸易方式" required>
                    <el-select :disabled="canEdit"  @change="changeData($event,'my')" remote :remote-method="remoteMethodmy" class="marr4" v-model="formData.vc_trade_type" size="mini" @clear="cleardata('my')" clearable filterable >
                        <el-option
                                v-for="item in tradeList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>-->

            </div>
            <div class="flex">
                <el-form-item  prop="f_price" label="成交价格" required>
                    <el-input-number :disabled="canEdit" class="changeinput number" @change="getsum(formData.f_price,'price')" v-model="formData.f_price" :min="0" :controls="false"></el-input-number>
                </el-form-item>
                <el-form-item  prop="f_num" label="数量" required>
                    <el-input-number :disabled="canEdit" class="changeinput number" @change="getsum(formData.f_num,'num')" v-model="formData.f_num" :min="0" :controls="false"></el-input-number>
                </el-form-item>
                <el-form-item  prop="f_amount" label="成交金额" required>
                    <el-input-number disabled class="changeinput number"  v-model="formData.f_amount" :min="0" :controls="false"></el-input-number>
                </el-form-item>
            </div>
            <div class="flex">

                <el-form-item  prop="vc_pay_type_cn"  label="付款方式(中" required>
                    <el-select :disabled="canEdit"  @change="changeData($event,'pay')" remote :remote-method="remoteMethodpay" class="marr4" v-model="formData.vc_pay_type_cn" size="mini" @clear="cleardata('pay')" clearable filterable >
                        <el-option
                                v-for="item in payList"
                                :key="item.i_id"
                                :label="item.vc_name_cn"
                                :value="item.vc_name_cn">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  prop="vc_pay_type_en"  label="付款方式(英" required>
                    <el-input disabled  class="changeinput" size="mini" v-model="formData.vc_pay_type_en"  ></el-input>
                </el-form-item>
                <el-form-item  prop="i_has_account_period"  label="是否有账期" required>
                    <el-radio-group class="changeinput"  disabled  v-model="formData.i_has_account_period">
                        <el-radio :label='0'>否</el-radio>
                        <el-radio :label='1'>是</el-radio>
                    </el-radio-group>
                </el-form-item>
            </div>
            <!--<div class="flex">
                <el-form-item  prop="vc_commodities_inspection" label="商检" required>
                    <el-input :disabled="canEdit"  class="changeinput" size="mini" v-model="formData.vc_commodities_inspection"  ></el-input>
                </el-form-item>
                <el-form-item  prop="vc_delivery" label="交货" required>
                    <el-input :disabled="canEdit"  class="changeinput" size="mini" v-model="formData.vc_delivery"  ></el-input>
                </el-form-item>
                <el-form-item  prop="vc_shipmenttime" label="出运日期要求" required>
                    <el-input :disabled="canEdit"  class="changeinput" size="mini" v-model="formData.vc_shipmenttime"  ></el-input>
                </el-form-item>
            </div>-->
            <!--<div class="flex">
                <el-form-item  prop="vc_tran_type" label="运输方式" required>
                    <el-select :disabled="canEdit"  @change="changeData($event,'ys')" remote :remote-method="remoteMethodys" class="marr4" v-model="formData.vc_tran_type" size="mini" @clear="cleardata('ys')" clearable filterable >
                        <el-option
                                v-for="item in tranList"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  prop="vc_station_start" label="起运港" required>
                    <el-select :disabled="canEdit"  @change="changeData($event,'qs')" remote :remote-method="remoteMethodgk" class="marr4" v-model="formData.vc_station_start" size="mini" @clear="cleardata('qs')" clearable filterable >
                        <el-option
                                v-for="item in gkData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  prop="vc_station_end" label="目的港" required>
                    <el-select :disabled="canEdit"  @change="changeData($event,'md')" remote :remote-method="remoteMethodgk" class="marr4" v-model="formData.vc_station_end" size="mini" @clear="cleardata('md')" clearable filterable >
                        <el-option
                                v-for="item in gkData"
                                :key="item.i_id"
                                :label="item.vc_name"
                                :value="item.vc_name">
                        </el-option>
                    </el-select>
                </el-form-item>
            </div>-->
            <div class="flex">
                <el-form-item class="form-title" prop="vc_ywuname" label="业务员" required>
                    <el-input :disabled="canEdit"  class="changeinput" size="mini" v-model="formData.vc_ywuname"  ></el-input>
                </el-form-item>
                <el-form-item class="form-title" prop="vc_lruname" label="录入人" >
                    <span  class="changeinput">{{formData.vc_lruname}}</span>
                </el-form-item>
                <el-form-item class="form-title" prop="dt_createtime" label="录入日期" >
                    <span  class="changeinput">{{formData.dt_createtime}}</span>
                </el-form-item>
            </div>
            <div class="flex">
                <!--<el-form-item class="form-title" prop="isuse" label="是否启用" required>
                    <el-radio-group :disabled="canEdit" v-removeAria v-model="formData.isuse">
                        <el-radio :label='0'>禁用</el-radio>
                        <el-radio :label='1'>启用</el-radio>
                    </el-radio-group>
                </el-form-item>-->
                <div class="flex" style="margin-left: 50px">
                    <el-upload
                            class="upload-demo"
                            style="padding-right: 20px"
                            :action="action"
                            :data="updata"
                            :http-request="beupload"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            multiple
                            :limit="10"
                            :file-list="fileList">
                        <!--:limit="limit"
                            :on-exceed="handleExceed"-->
                        <el-button size="mini" type="text">选择文件</el-button>
                    </el-upload>
                    <div>
                        <el-button :class="baseerp+'btn'" size="mini" type="primary" @click="submitUpload">上传</el-button>
                    </div>
                </div>
            </div>
        </el-form>
        <div slot="footer" class="dialog-footer" style="text-align: center">
            <template >
                <el-button type="primary" @click="saveForm('formRef')" :disabled="disabled" :class="baseerp+'btn'" size="small" >保存</el-button>
                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">编辑</el-button>
            </template>
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp,baseApp,file_url,baseVersion} from "@/utils/baseUrl";
    import {erpplatserver} from "@/utils/baseUrl";
    export default {
        name: "DetailPage",
        components: {},
        props:{
            data:{
                type:Object,
                required:true
            }
        },
        data() {
            return {
                fileList:[],
                action:erpplatserver+'/system/uploadInvoice',
                updata:{
                    // "file": fileId,
                    // "fileName": that.fileName,
                    // "IDtype": "",
                    // "type": 1,
                    "style": "invoicepool",
                    //"token":sessionStorage.getItem("token"),
                    //"app": "dsmanage",
                    "vc_app": "invoicepool",
                    "i_appid": 0,
                    // "version": "1.0",
                    // "i_uid": sessionStorage.getItem("userid"),
                    "vc_lruname":  sessionStorage.getItem("lruname"),
                    "i_lruid": sessionStorage.getItem("userid"),
                    // "i_mid": this.mid
                },
                ckData:[],
                payList:[],
                bzList:[],
                ksList:[],
                comList:[],
                gkData:[],
                tranList:[],
                tradeList:[],
                pzList:[],
                /*pickerOptions: {
                    disabledDate(time) {
                        let curDate=(new Date()),perM;
                        if(curDate.getMonth()>0){
                            perM=(new Date(curDate.getFullYear(),curDate.getMonth()-1,1)).getTime();
                        }else{
                            perM=(new Date(curDate.getFullYear()-1,11,1)).getTime();
                        }
                        let today=(new Date()).getDate();
                        let same=today*24*3600*1000;
                        // let sameMonth=curDate-same;//当月月初
                        let sameMonth=perM;
                        return time.getTime() > Date.now() || time.getTime() < sameMonth;
                        // const times = new Date(new Date().toLocaleDateString()).getTime() - 15 * 8.64e7 - 1;
                        // return time.getTime() > Date.now() || time.getTime() < times; // 如果Date.now() - 8.64e7没有后面的-8.64e7就是可以选择今天的
                    }
                },*/
                i_id:0,
                formData:{
                    //isuse:1,
                },
                baseerp:'',
                canEdit:false,
                disabled:false
            }
        },

        watch: {
            data: {
                handler() {
                    if (this.data) {
                        this.i_id=this.data.i_id;
                        // console.log(this.i_id,'this.i_id',this.data,'this.data')
                        if(this.i_id==0){
                            this.canEdit=false;
                            this.formData.dt_createtime=this.getDateYYYYMMddHHMMSS();
                            //this.formData.dt_signtime=this.getDateYYYYMMddHHMMSS();
                            this.formData.vc_lruname=sessionStorage.getItem("lruname");
                            this.formData.i_lruid=sessionStorage.getItem("userid");
                            //this.formData.i_target_company=0;
                            //this.formData.vc_target_company='';
                            this.formData.isuse=1;
                        }else{
                            this.formData=JSON.parse(JSON.stringify(this.data));
                            this.canEdit=true;
                        }
                        // console.log(this.fo,'foemate')
                    }
                },
                immediate: true,
                deep: true
            },
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.productlist('');
            //this.tradeTypeList('');
            //this.gettranList('');
            //this.getPortList('');
            this.warehouselist('');
            this.companylist('');
            this.list('');
            this.getbzList('');
            this.getpayList('');
            this.$nextTick(()=>{
                this.onResize();

            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-(n.h)*0.3-145;
                if(this.tableHeight<60)this.tableHeight=60;
            },
            beupload(obj){
                this.fileList.push(obj.file)
                //console.log(this.fileList, 'this.fileList');
            },
            handleRemove(obj, fileList) {
                this.fileList=fileList;
                //console.log(this.fileList, 'this.fileList');
                if(this.fileList.length==0){
                    this.vc_newname='';
                    this.vc_fpcode_upl='';
                    this.vc_pz_upl='';
                    this.f_pay_ws_upl='';
                    this.f_pay_zzs_upl='';
                    this.f_pay_upl='';
                    this.vc_note_upl='';
                    this.f_gs_upl='';
                }
            },
            handleExceed(files, fileList) {
                this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`);
            },
            async submitUpload() {
                if(this.fileList.length==0){
                    this.$message.error("上传前请先选择文件！")
                }
                return;
                this.loading_upl=true;
                var param = {
                    // "file": fileId,
                    // "fileName": that.fileName,
                    // "IDtype": "",
                    // "type": 1,
                    "style": "invoicepool",
                    //"token":sessionStorage.getItem("token"),
                    //"app": "dsmanage",
                    "vc_app": "invoicepool",
                    "i_appid": 0,
                    // "version": "1.0",
                    // "i_uid": sessionStorage.getItem("userid"),
                    "vc_lruname":  sessionStorage.getItem("lruname"),
                    "i_lruid": sessionStorage.getItem("userid"),
                    // "i_mid": this.mid
                };
                for (let i = 0; i < this.fileList.length; i++) {
                    //param.append("file", this.fileList[i]);
                    param['flie'+[i]]=this.fileList[i]
                }
                //console.log(param,'param')
                let res = await API.uploadInvoice(param);
                if (res.code == 1) {
                    this.files=res.data.fileList;
                    this.loading_upl=false;
                    this.$forceUpdate()
                    if(res.data.apicode==1){
                        let invoice = res.data.invoice;
                        let details = invoice.details;
                        this.details_upl = invoice.details;
                        let detailsL = invoice.details.length;
                        this.vc_fpcode_upl = invoice.vc_fpcode;
                        this.vc_pz_upl = detailsL==0?'':(detailsL==1?details[0].vc_fppzname:details[0].vc_fppzname+'等');
                        this.f_pay_ws_upl = invoice.f_pay_ws;
                        this.f_pay_zzs_upl = invoice.f_pay_zzs;
                        this.f_pay_upl = invoice.f_pay;
                        this.vc_note_upl = invoice.vc_note;
                        this.f_gs_upl = invoice.f_gs;
                        this.dt_fptime = invoice.dt_fptime;
                        this.vc_mainfile_newname= invoice.vc_mainfile_newname;
                    }else{
                        let string='';
                        string=res.data.fileList.map(item=>item.vc_path).join(';')
                        //console.log(string,'string')
                        this.vc_mainfile_newname=string;
                    }
                } else if (res.code == -2) {
                    this.loading_upl=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.loading_upl=false;
                    this.$message.error(res.message);
                }

            },
            getsum(e,type){
                //console.log(e,'e',type,'type')
                let amount = 0;
                if(type=='price'){
                    amount = (e*this.formData.f_num).toFixed(this.$setPrecision.quantityPrecision)
                }
                if(type=='num'){
                    amount = (e*this.formData.f_price).toFixed(this.$setPrecision.quantityPrecision)
                }
                this.formData.f_amount=amount;
                this.$nextTick(()=>{
                    this.$forceUpdate()
                })
            },
            editForm(){
                this.canEdit=false
            },
            saveForm(data){
                this.$refs[data].validate((valid)=>{
                    if(valid){
                        this.savePayment()
                    }else{
                        return false;
                    }
                })
                /*if(this.formData.i_khid==''||this.formData.i_khid==undefined||this.formData.i_gsid==''||(this.formData.i_isbankcharges===0&&this.formData.vc_bank_account=='')||this.formData.f_pay==0||this.formData.f_rate==0){
                    this.$message.warning('请填写必需项')
                }else{
                    if(this.formData.i_id==0){
                        this.savePayment()
                    }else{
                        this.formData.i_cid=this.formData.i_khid
                        this.formData.vc_cname=this.formData.vc_khname
                        this.updateHistoryPayment()
                    }
                    this.disabled=true
                }*/
            },
            cancel(){
                this.$emit('close')
            },
            changeData(e,type){
                //console.log('e',e)
                if(this.pzList.length!=0&&type=='pz'){
                    let choo = this.pzList.filter(item=>{
                        return item.vc_name_cn == e
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.formData.vc_product_type=choo[0].vc_type;
                        this.formData.i_product_type=choo[0].i_type;
                        this.formData.vc_product=choo[0].vc_name_cn;
                        this.formData.i_product=choo[0].i_id;
                        this.formData.vc_unit=choo[0].vc_unit;
                    }else{
                        this.formData.vc_product_type='';
                        this.formData.i_product_type=0;
                        this.formData.vc_product='';
                        this.formData.i_product=0;
                        this.formData.vc_unit='';
                    }
                }
                if(this.tradeList.length!=0&&type=='my'){
                    let choo = this.tradeList.filter(item=>{
                        return item.vc_name == e
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.formData.vc_trade_type=choo[0].vc_name;
                        this.formData.i_trade_type=choo[0].i_id;
                    }else{
                        this.formData.vc_trade_type='';
                        this.formData.i_trade_type=0;
                    }
                }
                if(this.tranList.length!=0&&type=='ys'){
                    let choo = this.tranList.filter(item=>{
                        return item.vc_name == e
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.formData.vc_tran_type=choo[0].vc_name;
                        this.formData.i_tran_type=choo[0].i_id;
                    }else{
                        this.formData.vc_tran_type='';
                        this.formData.i_tran_type=0;
                    }
                }
                if(type=="qs"){
                    this.formData.vc_station_start=e;
                    if(this.formData.vc_station_start==this.formData.vc_station_end){
                        this.$message.error("起始目的港不能为同一个港口！");
                        this.formData.i_station_start=0;
                        this.formData.vc_station_start="";
                        return ;
                    }else{
                        let choo = this.gkData.filter((item,index)=>{
                            return item.vc_name == e
                        });
                        if(choo.length!=0){
                            this.formData.i_station_start=choo[0].i_id;
                            this.formData.vc_station_start=choo[0].vc_name;
                        }else{
                            this.formData.i_station_start=0;
                            this.formData.vc_station_start='';
                        }
                    }
                }
                if(type=="md"){
                    this.formData.vc_station_end=e;
                    if(this.formData.vc_station_start==this.formData.vc_station_end){
                        this.$message.error("起始目的港不能为同一个港口！");
                        this.formData.i_station_end=0;
                        this.formData.vc_station_end="";
                        return ;
                    }else{
                        let choo = this.gkData.filter((item,index)=>{
                            return item.vc_name == e
                        });
                        if(choo.length!=0){
                            this.formData.i_station_end=choo[0].i_id;
                            this.formData.vc_station_end=choo[0].vc_name;
                        }else{
                            this.formData.i_station_end=0;
                            this.formData.vc_station_end='';
                        }
                    }
                }
                if(type=="com"){
                    let choo = this.comList.filter(item=>{
                        return item.vc_name == e
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.formData.vc_seller=choo[0].vc_name;
                        this.formData.i_seller=choo[0].i_id;
                    }else{
                        this.formData.vc_seller='';
                        this.formData.i_seller=0;
                    }
                }
                if(type=="com_md"){
                    let choo = this.comList.filter(item=>{
                        return item.vc_name == e
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.formData.vc_target_company=choo[0].vc_name;
                        this.formData.i_target_company=choo[0].i_id;
                    }else{
                        this.formData.vc_target_company='';
                        this.formData.i_target_company=0;
                    }
                }
                if(type=="ks"){
                    let choo = this.ksList.filter(item=>{
                        return item.vc_name == e
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.formData.vc_buyer=choo[0].vc_name;
                        this.formData.i_buyer=choo[0].i_id;
                    }else{
                        this.formData.vc_buyer='';
                        this.formData.i_buyer=0;
                    }
                }
                if(type=="bz"){
                    let choo = this.bzList.filter(item=>{
                        return item.vc_name == e
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.formData.vc_bzname=choo[0].vc_name;
                        this.formData.i_bzid=choo[0].i_id;
                        this.formData.vc_bz_symbol=choo[0].vc_symbol;
                    }else{
                        this.formData.vc_bzname='';
                        this.formData.i_bzid=0;
                        this.formData.vc_bz_symbol='';
                    }
                }
                if(type=="pay"){
                    let choo = this.payList.filter(item=>{
                        return item.vc_name_cn == e
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.formData.vc_pay_type_cn=choo[0].vc_name_cn;
                        this.formData.vc_pay_type_en=choo[0].vc_name_en;
                        this.formData.i_pay_type=choo[0].i_id;
                        this.formData.i_has_account_period=choo[0].i_has_account_period;
                    }else{
                        this.formData.vc_pay_type_cn='';
                        this.formData.vc_pay_type_en='';
                        this.formData.i_pay_type=0;
                        this.formData.i_has_account_period='';
                    }
                }
                if(type=="ck"){
                    let choo = this.ckData.filter(item=>{
                        return item.vc_name == e
                    });
                    //console.log(choo)
                    if(choo.length>0){
                        this.formData.i_ckid=choo[0].i_id;
                        this.formData.vc_ckname=choo[0].vc_name;
                    }else{
                        this.formData.i_ckid=0;
                        this.formData.vc_ckname='';
                    }
                }
                this.$nextTick(()=>{
                    this.$forceUpdate()
                })
            },
            cleardata(type){
                if(type=='pz')this.productlist('');
                if(type=='my')this.tradeTypeList('');
                if(type=='ys')this.gettranList('');
                if(type=="qs"||type=="md")this.getPortList('');
                if(type=="com"||type=='com_md')this.companylist('');
                if(type=="ks")this.list('');
                if(type=="bz")this.getbzList('');
                if(type=="pay")this.getpayList('');
                if(type=="ck")this.warehouselist('');
            },
            remoteMethodpz(val){
                this.productlist(val)
            },
            remoteMethodmy(val){
                this.tradeTypeList(val)
            },
            remoteMethodys(val){
                this.gettranList(val)
            },
            remoteMethodgk(val){
                this.getPortList(val)
            },
            remoteMethodcom(val){
                this.companylist(val)
            },
            remoteMethodks(val){
                this.list(val)
            },
            remoteMethodbz(val){
                this.getbzList(val)
            },
            remoteMethodpay(val){
                this.getpayList(val)
            },
            remoteMethodck(val){
                this.warehouselist(val)
            },
            //客商列表
            async list(val){
                let param={
                    i_mid:this.mid,
                    currentPage:1,
                    pageSize:50,
                    vc_search:val,
                    isuse:1,
                };
                let res=await API.list(param);
                if(res.code==1){
                    this.ksList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //公司列表
            async companylist(val){
                let param={
                    i_mid:this.mid,
                    currentPage:1,
                    pageSize:50,
                    vc_search:val,
                    isuse:1,
                };
                let res=await API.companylist(param);
                if(res.code==1){
                    this.comList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //港口列表
            async getPortList(val){
                let param={
                    i_mid:this.mid,
                    i_type:2,
                    currentPage:1,
                    pageSize:50,
                    vc_search:val,
                };
                //console.log(param,'param');
                let res=await API.warehouselist(param);
                if(res.code==1){
                    this.gkData=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //ck列表
            async warehouselist(val){
                let param={
                    i_mid:this.mid,
                    i_type:1,
                    currentPage:1,
                    pageSize:50,
                    vc_search:val,
                };
                //console.log(param,'param');
                let res=await API.warehouselist(param);
                if(res.code==1){
                    this.ckData=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getpayList(val){
                let param={
                    i_mid:this.mid,
                    currentPage:1,
                    pageSize:50,
                    vc_search:val,
                };
                //console.log(param,'param');
                let res=await API.payType(param);
                if ( res.code == 1 ){
                    this.payList=res.data.list
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async gettranList(val){
                let param={
                    i_mid:this.mid,
                    currentPage:1,
                    pageSize:50,
                    vc_search:val,
                };
                //console.log(param,'param');
                let res=await API.tranType(param);
                if ( res.code == 1 ){
                    this.tranList=res.data.list
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async getbzList(val){
                let param={
                    i_mid:this.mid,
                    currentPage:1,
                    pageSize:50,
                    vc_search:val,
                };
                //console.log(param,'param');
                let res=await API.bzList(param);
                if ( res.code == 1 ){
                    this.bzList=res.data.list
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async tradeTypeList(val){
                let param={
                    i_mid:this.mid,
                    currentPage:1,
                    pageSize:50,
                    vc_search:val,
                };
                //console.log(param,'param');
                let res=await API.tradeTypeList(param);
                if ( res.code == 1 ){
                    this.tradeList=res.data.list
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            async productlist(val){
                let param={
                    i_mid:this.mid,
                    currentPage:1,
                    pageSize:50,
                    vc_search:val,
                    isuse:1,
                };
                //console.log(param,'param');
                let res=await API.productlist(param);
                if ( res.code == 1 ){
                    this.pzList=res.data.list
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            /*changegb(){
                return
                this.formData.vc_bank_account='';
                this.formData.f_pendingamount='';
                this.yhzhList=[]
                if(this.formData.i_gsid){
                    this.formData.vc_gsname=this.gsList.find(gs=>gs.i_id==this.formData.i_gsid).vc_name;
                    this.getAccountByGsid()
                    if(this.formData.i_khid&&this.formData.vc_bank_account&&this.formData.i_bzid) {
                        this.getPendingAmounts()
                    }
                }
            },*/
            async savePayment(){
                let list = [];
                list.push(this.formData)
                let param={
                    list:list
                };
                //console.log('param',param)
                let res=await API.sellsave(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false
                }
            },
            /*async updateHistoryPayment(){
                let param={
                    i_id:this.formData.i_id,
                    i_cid:this.formData.i_cid,
                    i_gsid:this.formData.i_gsid,
                    vc_gsaccount:this.formData.vc_gsaccount,
                    vc_cname:this.formData.vc_cname,
                    vc_name_bank:this.formData.vc_name_bank,
                    i_hpstatus:this.formData.i_hpstatus,
                    vc_type:this.formData.vc_type,
                };
                let res=await API.updateHistoryPayment(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.$emit('close','save');
                    this.disabled=false
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    this.disabled=false

                }
            },*/

            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`

            },
        },
    }
</script>

<style lang="scss" scoped>
    /deep/.number .el-input__inner{
        text-align: left !important;
    }
    .flex{
        display:flex;
    }
    .jcsb{
        justify-content: space-around;

    }
    .changeinput{
        width: 200px;
        display: inline-block;
    }
</style>